import React, { FunctionComponent } from 'react';
import { Form, Field } from 'react-final-form';
import i18next from 'i18next';

import { requiredValidation } from 'helpers/validations';
import Input from 'components/inputs/Input';
import { ViewContainer, ViewContent } from 'styles/view';

import { IContactSettingsViewProps } from './types';
import { Description, FormContainer, ActionsWrapper, StyledButton, Loader } from './styles';

const ContactSettingsView: FunctionComponent<IContactSettingsViewProps> = ({
  initialValues,
  onSubmit,
  loading,
}) => {
  return (
    <ViewContainer auth>
      <ViewContent auth>
        <Description variant="body1">
          {i18next.t<String>(
            'CONTACT_SETTINGS_VIEW:DESCRIPTION',
            'Configure el número de WhatsApp que verán los clientes para realizar consultas sobre sus trámites.',
          )}
        </Description>

        <Form
          initialValues={initialValues}
          onSubmit={onSubmit}
          render={({ handleSubmit, pristine, invalid }) => (
            <form onSubmit={handleSubmit}>
              <FormContainer>
                <Field
                  label={i18next.t<String>(
                    'CONTACT_SETTINGS_VIEW:WHATSAPP_LABEL',
                    'Número de WhatsApp',
                  )}
                  name="whatsappNumber"
                  render={Input}
                  type="number"
                  validate={requiredValidation}
                  placeholder="Ej: 5491112345678"
                  helperText={i18next.t<String>(
                    'CONTACT_SETTINGS_VIEW:HELPER_TEXT',
                    'Incluir código de país y área (sin el 15).',
                  )}
                  format={(v) => v || ''}
                />

                <ActionsWrapper>
                  <StyledButton
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={loading || pristine || invalid}
                  >
                    {i18next.t<String>('CONTACT_SETTINGS_VIEW:SAVE')}
                  </StyledButton>

                  {loading && <Loader size={24} />}
                </ActionsWrapper>
              </FormContainer>
            </form>
          )}
        />
      </ViewContent>
    </ViewContainer>
  );
};

export default ContactSettingsView;
